//@flow
import React, { Component } from 'react';

import { LgDesktop, SmDesktop } from '../../Responsive';
import { CustomModelListTh } from '../StatisticsStyles';

type Props = {
  options: Array<any>
};

export default class TableHeaderDesktop extends Component<Props> {
  render() {
    // $FlowFixMe
    return this.props.options.map(item => (
      <>
        <LgDesktop>
          <CustomModelListTh
            right={item.right}
            customWidth={item.lgCustomWidth}
          >
            {item.lg}
          </CustomModelListTh>
        </LgDesktop>
        <SmDesktop>
          <CustomModelListTh
            right={item.right}
            customWidth={item.smCustomWidth}
          >
            {item.sm}
          </CustomModelListTh>
        </SmDesktop>
      </>
    ));
  }
}
